export default {
  // 设置默认图片
  defaultImg () {
    return 'this.src="' + require('@/assets/images/default.png') + '"'
  },
  splitString (value) {
    if (!value) {
      return
    }
    let arr = value.split(',')
    return arr
  },

  // 带时分秒
  renderTime (date) {
    if (!date) {
      return
    }
    var dateee = new Date(date).toJSON()
    return new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
  },
  formatDate (date, fmt) {
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    let o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds()
    }
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + ''
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : this.padLeftZero(str))
      }
    }
    return fmt
  },
  // 年月日
  formatTime (time) {
    if (!time) {
      return '--'
    }
    let date = new Date(time)
    return this.formatDate(date, 'yyyy/MM/dd')
  },
  padLeftZero (str) {
    return ('00' + str).substr(str.length)
  },

  /*
* 获取某个元素下标
* arr: 传入的数组
* obj: 需要获取下标的元素
* */
  getArrayIndex (arr, obj) {
    var i = arr.length
    while (i--) {
      if (arr[i] === obj) {
        return i
      }
    }
    return -1
  },
  uuid () {
    var s = []
    var hexDigits = '0123456789abcdef'
    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
    }
    s[14] = '4'
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
    s[8] = s[13] = s[18] = s[23] = '-'
    var uuid = s.join('')
    return uuid
  }
}



// WEBPACK FOOTER //
// ./src/utils/commonFunctions.js